import React from 'react';
import { Link } from 'react-router-dom';
import logo from '@isomorphic/shared/isomorphic/assets/images/logo_white.png';
import icon from '@isomorphic/shared/isomorphic/assets/images/icon.png';

export default ({ collapsed }) => {
  return (
    <div className="isoLogoWrapper">
      {collapsed ? (
        <div>
          <h3>
            <Link to="/">
              <img src={icon} width="30" />
            </Link>
          </h3>
        </div>
      ) : (
        <h3>
          <Link to="/">
            <img src={logo} width="200" />
          </Link>
        </h3>
      )}
    </div>
  );
};
